import React from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { setSubscription } from './acoes/MySubscriptionsActions';
import { CardAccordion, AccordionLayout} from 'react-template';
import SubscriptionView from '../../components/view/SubscriptionView';
import {formatLongToDate} from '../../helpers/Data'
import {View} from 'react-template'
import "../../assets/css/view/inicio/index.css"
import "../../assets/css/view/inicio/mySubscriptions.css"

class MySubscriptions extends View {

    componentWillMount(){
        if(this.props.cpf.length === 0){
            this.redirect('/');
        }
    }

    renderAccordionItem(submissao, index){
        const idSubmissao = submissao.id;
        const tituloFormulario = JSON.parse(submissao.form.formSchema).schema.title;
        const dataSubmissao = formatLongToDate(submissao.dataSubmissao);
        return(
            <div>
                <CardAccordion titulo={tituloFormulario+' - '+dataSubmissao} key={index}>
                <SubscriptionView 
                    submissao={submissao}
                    pesquisa_submissao={true}
                    key={idSubmissao}
                    tem_presenca={submissao.form.certificado}/>
                </CardAccordion>
            </div>
        )
    }

    render() {
        return (
            <div id='see-inscription'>
            <AccordionLayout titulo='Minhas Inscrições' descricao={this.props.cpf}>
                {this.props.submissoes.map( (submissao, index) => (
                    this.renderAccordionItem(submissao, index)
                ))}
            </AccordionLayout>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
       submissoes: state.MySubscriptionsReducers.submissoes,
       cpf: state.MySubscriptionsReducers.cpf,
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ setSubscription }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(MySubscriptions);


// WEBPACK FOOTER //
// ./src/view/inicio/MySubscriptions.js